module.exports = __webpack_public_path__ + "static/media/horsel.6a5281de.6a5281de.svg";